var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgCheckboxEmpty(props) {
    return (React.createElement("svg", __assign({ fill: '#FFF', stroke: '#242424', viewBox: '-1 -1 18 18' }, props),
        React.createElement("rect", { width: 16, height: 16, fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 1.5, rx: 5 })));
}
export default SvgCheckboxEmpty;
//# sourceMappingURL=CheckboxEmpty.js.map